// extracted by mini-css-extract-plugin
export var content = "block-wrapper-module--content--09768";
export var wrapper = "block-wrapper-module--wrapper--aea9d container-module--wrapper--c1517";